module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-top-stone-path-background-remnants.533c546c.png";